import { rem, transparentize } from "polished";
import React from "react";
import styled, { css } from "styled-components";
import Drawer from "../Drawer";
import clsx from "clsx";
import makePayload from "../Cart/AddToCart/make-payload";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../lib/redux/slices/cart-slice";
import { Spinner } from "../Spinner";

const Header = () => {
  const [openDrawer, onSetDrawer] = React.useState(false);
  const cartPayload = useSelector((s) => s);
  const cartData = useSelector((s) => s.cart);
  const dispatch = useDispatch();

  const { loading, data } = cartData;
  const currency = (data && data.currency) || "kr";

  const handleContinue = () => {
    onSetDrawer(!openDrawer);
    if (!openDrawer) {
      const payload = makePayload(cartPayload);
      dispatch(addToCart(payload));
    }
  };

  const getContent = (title, data) => {
    return (
      <div className="content-body">
        <div className="item-header">{title}</div>
        <div className="item-body">
          <ul>
            {Object.entries(data).map((item) => {
              return item[1].length
                ? item[1].map((ite) => {
                    return (
                      <li>
                        <span dangerouslySetInnerHTML={{ __html: ite.title }} />
                        {/* <span>{ite.title}</span> */}
                        <span>{[ite.price, currency].join(" ")}</span>
                      </li>
                    );
                  })
                : null;
            })}
          </ul>
        </div>
      </div>
    );
  };

  return (
    <HeaderLayout>
      <div
        className="cart"
        onClick={() => {
          handleContinue();
        }}
      >
        <div
          className={clsx("cart-icons", {
            open: openDrawer,
          })}
        >
          Varukorg <span class="badge badge-secondary">1</span>
          <span class="icon-basket" />
        </div>
      </div>

      <Drawer
        wrapperId="cart"
        isOpen={openDrawer}
        handleClose={() => {
          onSetDrawer(false);
        }}
        parentStyle={{
          height: "100%",
        }}
        position="right"
        hasOverlay={true}
        // disableOverlayClick={true}
        fullWidth={false}
        styles={{
          maxWidth: "300px",
          zIndex: 9999,
        }}
      >
        <DrawerContent>
          <div className="title">
            <div>Specifikation</div>
            <div
              className="close-icon"
              onClick={() => {
                onSetDrawer(!openDrawer);
              }}
            >
              <span />
              <span />
            </div>
          </div>
          {loading === "resolved" ? (
            <div className="content">
              {getContent("ARTIKLAR", data.artiklar)}
              {data?.kantprofiler?.length
                ? getContent("KANTPROFILER", {
                    data: data.kantprofiler,
                  })
                : null}

              <div className="content-body">
                <div className="item-header">TOTALT</div>
                <div className="item-body">
                  <ul>
                    <li>
                      <span>{data.vat.title}</span>
                      <span>{data.vat.formatted_price}</span>
                    </li>
                    <li>
                      <span>{data.totalAmount.title}</span>
                      <span>
                        {data.totalAmount.formatted_price}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          ) : (
            <Spinner strokeWidth={10} width={50} className="centerAlign" />
          )}
        </DrawerContent>
      </Drawer>
    </HeaderLayout>
  );
};
export default Header;

const HeaderLayout = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    right: 0;

    .cart {
      .cart-icons {
        display: flex;
        align-items: center;

        span {
          margin-left: 10px;
        }
      }
      .cart-icon {
        width: 30px;
        height: 30px;
        position: relative;
        cursor: pointer;
        padding: ${rem(10)};
        transition: 0.3s ease all;

        span {
          position: absolute;
          top: 50%;
          left: 50%;
          width: calc(100% - 10px);
          margin: 0 auto;
          height: 2px;
          border-radius: 3px;
          background-color: ${theme.colors.black};
          transform: translate(-50%, -50%);
          transition: 0.3s ease all;

          &:nth-child(1) {
            top: calc(50% - 6px);
          }
          &:nth-child(3) {
            top: calc(50% + 6px);
          }
        }
        &.open {
          opacity: 0;
        }

        /* &.open {
          span {
            opacity: 0;
            background-color: ${theme.colors.primary};

            &:nth-child(1),
            &:nth-child(3) {
              top: 50%;
              opacity: 1;
            }

            &:nth-child(1) {
              transform: translate(-50%, -50%) rotate(45deg);
            }
            &:nth-child(3) {
              transform: translate(-50%, -50%) rotate(-45deg);
            }
          }
        } */
      }
    }
  `}
`;

const DrawerContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    height: 100%;

    .title {
      text-align: center;
      padding: ${rem(27)} ${rem(15)};
      font-size: ${rem(20)};
      color: ${theme.colors.primary};
      display: flex;
      align-items: center;
      justify-content: space-between;

      .close-icon {
        position: relative;
        width: 30px;
        height: 30px;
        cursor: pointer;

        span {
          position: absolute;
          top: 50%;
          left: 50%;
          width: calc(100% - 10px);
          margin: 0 auto;
          height: 2px;
          border-radius: 3px;
          transform: translate(-50%, -50%);
          transition: 0.3s ease all;
          background-color: ${theme.colors.primary};

          &:nth-child(1),
          &:nth-child(2) {
            top: 50%;
            opacity: 1;
          }

          &:nth-child(1) {
            transform: translate(-50%, -50%) rotate(45deg);
          }
          &:nth-child(2) {
            transform: translate(-50%, -50%) rotate(-45deg);
          }
        }
      }
    }

    .content {
      overflow: hidden auto;
      height: 100%;
      flex-grow: 1;
      border-bottom: 20px solid transparent;

      &::-webkit-scrollbar {
        width: 5px;

        /* Track */
        &-track {
          box-shadow: inset 0 0 5px ${theme.colors.gray["500"]};
          border-radius: 10px;
        }

        /* Handle */
        &-thumb {
          background: ${theme.colors.primary};
          border-radius: 10px;
          height: 5px;

          &:hover {
            background: ${transparentize(0.2, theme.colors.primary)};
          }
        }
      }

      .content-body {
        .item-header {
          padding: 15px;
          background-color: ${theme.colors.primary};
          color: ${theme.colors.white};
          font-size: 14px;
          position: sticky;
          top: 0;
        }

        .item-body {
          padding: 15px;

          ul {
            margin: 0;
            padding: 0;
            list-style: none;

            li {
              span {
                font-size: 14px;
                max-width: 70%;
                display: inline-block;
                vertical-align: middle;
                width: 100%;
                padding: 0 10px;

                &:last-child {
                  max-width: 30%;
                  text-align: right;
                }
              }

              + li {
                margin-top: 15px;
              }
            }
          }
        }
      }
    }
  `}
`;
